<template>
<div class="chapter">
<div class="inner_page">
<p class="running_top_indent"><a id="page_4"></a>Lord of the universe: I am a simple man, an ignorant man. Oh, how I wish I had the words to fashion beautiful prayers to praise thee! But alas, I cannot find the words. So, listen to me, O God, as I recite the alphabet. You know what I think and how I feel. Take these letters of the alphabet and you form the words to express the yearning, the love for thee, that is in my heart.</p>
<p class="right"><span class="small">UNKNOWN</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03frontmatter01.vue?7b817e1a